module.exports = __webpack_public_path__ + "static/shotlists_shots@2x-4ff47ec6a80dda1d1e71a622c468c68d.png";